export default "__VITE_ASSET__9be3666b__"